import React from 'react';
import { Box, Chip, Paper, Typography, useTheme } from '@mui/material';
import { IconMessageCircle2, IconHistory } from '@tabler/icons';
import { formatTicketDate } from './ticketUtils';

// Um item da timeline do Ticket - comentário humano (balão, autor +
// texto) ou evento do sistema (linha compacta, cinza) - só a
// cor/formato distingue os dois, mesmo espírito de como JanelaConversa.js
// diferencia mensagem de cliente/agente/chatbot só por cor de fundo,
// sem componente novo pesado.
const TicketTimelineItem = ({ item }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const authorName = item.author_detail
        ? `${item.author_detail.first_name || ''} ${item.author_detail.last_name || ''}`.trim() || item.author_detail.username
        : 'Sistema';

    if (item.kind === 'event') {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.75, px: 1 }}>
                <IconHistory size={15} color={isDark ? '#8696a0' : '#667781'} style={{ flexShrink: 0 }} />
                <Typography variant="caption" sx={{ color: isDark ? '#8696a0' : '#667781' }}>
                    {item.message}
                    {' — '}
                    {authorName}
                    {' · '}
                    {formatTicketDate(item.created_at)}
                </Typography>
            </Box>
        );
    }

    return (
        <Paper
            elevation={0}
            sx={{
                p: 1.5,
                borderRadius: 2,
                background: isDark ? '#1f2c33' : '#f7f8fa',
                border: `1px solid ${isDark ? '#2a3942' : '#e6e8eb'}`
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <IconMessageCircle2 size={16} color={isDark ? '#e9edef' : '#111'} />
                <Typography fontWeight={600} variant="body2">
                    {authorName}
                </Typography>
                {item.internal && (
                    <Chip
                        label="Interno"
                        size="small"
                        sx={{ height: 18, fontSize: 11, fontWeight: 600, bgcolor: isDark ? '#3a2f1f' : '#FFF3CD', color: isDark ? '#f0d585' : '#8A6D00' }}
                    />
                )}
                <Typography variant="caption" sx={{ ml: 'auto', color: isDark ? '#8696a0' : '#667781' }}>
                    {formatTicketDate(item.created_at)}
                </Typography>
            </Box>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {item.message}
            </Typography>
        </Paper>
    );
};

export default TicketTimelineItem;
